import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const GlobalAdmin = lazy(() =>
  import('./admin').then(m => ({default: m.GlobalAdmin})),
)

const InnerBlock = lazy(() =>
  import('./CartBlock').then(m => ({default: m.CartBlock})),
)

export const cartBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  GlobalAdmin,
  InnerBlock,
})
